import $i18n from '@/locales/i18n';
import classNames from 'classnames';
import { useState } from 'react';
import { BLOCK, TILE } from '@/common/util/const';
import { createBlockSnippet } from '@/common/manager/setter-snippet';
import { makeColumnDom } from './dom';
import './index.scss';
const { CnBalloon } = window?.CNUI || {};
const isMobile = window.cnLowcodeStore?.page?.pageSubtype === 'MOBILE';
const FUSION_UI_VIEW_PREFIX = 'fd-layout-view';
const addNewBlock = (_leaf) => {
    const children = _leaf?.schema?.children;
    const prevBlockSchema = [...((Array.isArray(children) ? children : []) || [])]
        .reverse()
        .find((n) => typeof n === 'object' && [TILE, BLOCK].includes(n.componentName)) ||
        createBlockSnippet();
    const prevBlockProps = { ...prevBlockSchema.props };
    delete prevBlockProps.operation;
    const blockSchema = createBlockSnippet({
        cardProps: {
            title: $i18n.get({ id: 'Title', dm: '标题' }),
        },
        blockProps: {
            ...prevBlockProps,
            span: 12,
        },
    });
    const newNode = _leaf?.document?.createNode(blockSchema);
    newNode && _leaf?.insertAfter(newNode);
};
const batchAddNewBlock = (_leaf, blockSpanStr) => {
    const blockSpanList = blockSpanStr?.split(':');
    if (Array.isArray(blockSpanList)) {
        let cardProps = {};
        if (_leaf?.parent?.componentName === 'CnCard') {
            cardProps = {
                noPadding: true,
                noShadow: true,
                title: $i18n.get({ id: 'Title', dm: '标题' }),
                shape: 'simple',
            };
            if (_leaf.parent.propsData?.shape === 'group') {
                cardProps.noPadding = false;
                cardProps.noShadow = false;
                cardProps.shape = 'normal';
            }
        }
        for (const blockSpan of blockSpanList) {
            const blockSchema = createBlockSnippet({
                cardProps,
                blockProps: {
                    span: Number(blockSpan),
                },
            });
            const newNode = _leaf?.document?.createNode(blockSchema);
            newNode && _leaf?.insertAfter(newNode);
        }
    }
};
/**
 * @description 自由布局容器提供的插入新分栏能力
 */
export const AddTile = (props) => {
    const [ballonVisible, setBallonVisible] = useState(false);
    const { _leaf } = props || {};
    let dom = null;
    if (isMobile) {
        dom = (<div onClick={() => addNewBlock(_leaf)} className={`${FUSION_UI_VIEW_PREFIX}-icon-add`}/>);
    }
    else {
        dom = (<div className={classNames(`${FUSION_UI_VIEW_PREFIX}-icon-add`, {
                [`${FUSION_UI_VIEW_PREFIX}-icon-add-focus`]: ballonVisible,
            })}/>);
    }
    return (<div className={`${FUSION_UI_VIEW_PREFIX}-block-add`}>
      {!isMobile && CnBalloon ? (<CnBalloon v2 closable={false} align={'b'} popupStyle={{ minWidth: '312px' }} trigger={dom} onVisibleChange={(visible) => {
                setBallonVisible(visible);
            }}>
          <div className="cn-layout-setter-item-container">
            <div className="cn-layout-setter-item-title">
              {$i18n.get({
                id: 'InsertANewColumnBelowTheCurrentR_1664352081',
                dm: '当前行下方插入新分栏',
            })}
            </div>

            <div className={'cn-layout-setter-item-content'}>
              {makeColumnDom({
                value: '',
                onClick: (newV) => {
                    batchAddNewBlock(_leaf, newV);
                },
            })}
            </div>
          </div>
        </CnBalloon>) : (dom)}
    </div>);
};
